/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Pattern_Disabled_UnnamedInputs */



/**
* | output |
* | --- |
* | "This pattern is no longer monitoring requests" |
*
* @param {Audit_Details_Pattern_Disabled_UnnamedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_pattern_disabled_unnamed = /** @type {((inputs?: Audit_Details_Pattern_Disabled_UnnamedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Pattern_Disabled_UnnamedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Muster überwacht keine Anfragen mehr")
	return /** @type {LocalizedString} */ ("This pattern is no longer monitoring requests")
});